const normalizeGroup = (touristGroup) => {
    const result = {};

    if (touristGroup.adults) {
        result.adults = touristGroup.adults;
    }
    if (touristGroup.kids) {
        result.kids = touristGroup.kids;
    }
    if (touristGroup.infants) {
        result.infants = touristGroup.infants;
    }
    if (touristGroup.ages?.length) {
        result.ages = touristGroup.ages;
    }

    return result;
}

export default (tourCriteria) => {
    let params = null;
    const element = tourCriteria.get('touristGroup');
    if (!element) {
        return params;
    }

    const parsedGroup = element.toJSON();

    if (parsedGroup?.touristsByRooms?.length > 0) {
        params = {
            rooms: [normalizeGroup(parsedGroup), ...parsedGroup.touristsByRooms.map(normalizeGroup)]
        };
    } else  {
        params = normalizeGroup(parsedGroup);
    }

    return params;
};